import Tutoriales from "components/inicio/Tutoriales";
import React  from 'react';

function TutorialesPage() {
  return <Tutoriales />;
}

export default TutorialesPage;
